import Waiting from '@/store/waiting';

export default class OpportunityCustomFieldActions {
  constructor (Api, types) {
    const actions = {
      async getOpportunityCustomFieldsAction ({ commit }, args) {
        await waiting.check('getOpportunityCustomFieldsAction', async () => {
          try {
            const res = await Api.getOpportunityCustomFields(args);
            commit(types.SET_OPPORTUNITY_CUSTOM_FIELDS, Object.values(res.data)[0]);
          } catch (err) {
            throw err;
          }
        });
      },
      async createOpportunityCustomFieldAction ({ dispatch }, args) {
        await waiting.check('createOpportunityCustomFieldAction', async () => {
          await Api.createOpportunityCustomField(args);
          try {
            await dispatch('getOpportunityCustomFieldsAction', args);
          } catch (err) {
            throw err;
          }
        });
      },
      async updateOpportunityCustomFieldAction ({ dispatch }, args) {
        await waiting.check('updateOpportunityCustomFieldAction', async () => {
          await Api.updateOpportunityCustomField(args);
          try {
            await dispatch('getOpportunityCustomFieldsAction', args);
          } catch (err) {
            throw err;
          }
        });
      },
      async updateOpportunityCustomFieldsAction ({ dispatch }, args) {
        await waiting.check('updateOpportunityCustomFieldsAction', async () => {
          await Api.updateOpportunityCustomFields(args);
          try {
            await dispatch('getOpportunityCustomFieldsAction', args);
          } catch (err) {
            throw err;
          }
        });
      },
      async deleteOpportunityCustomFieldAction ({ dispatch }, args) {
        await waiting.check('deleteOpportunityCustomFieldAction', async () => {
          await Api.deleteOpportunityCustomField(args);
          try {
            await dispatch('getOpportunityCustomFieldsAction', args);
          } catch (err) {
            throw err;
          }
        });
      },
      async deleteOpportunityCustomFieldOptionAction ({ dispatch }, args) {
        await waiting.check('deleteOpportunityCustomFieldOptionAction', async () => {
          await Api.deleteOpportunityCustomFieldOption(args);
          try {
            await dispatch('getOpportunityCustomFieldsAction', args);
          } catch (err) {
            throw err;
          }
        });
      },
    };
    const waiting = new Waiting(actions);
    this.actions = actions;
  }
}
